<template>
  <v-container align-center justify-center fill-height text-xs-center>
    <div>
      <v-btn
          color="primary"
          large
          v-google-signin-button="clientId"
          class="ma-0 mb-3"
          @click="error = false"
      >Continue with Google
      </v-btn>

      <p>Only <strong>Front.id</strong> accounts allowed.</p>

      <v-card v-if="error">
        <v-card-text>
          This google account is not valid. or does not belong to Front.id
        </v-card-text>
      </v-card>

    </div>
  </v-container>

</template>


<script>
  import { mapState } from "vuex"
  import GoogleSignInButton from 'vue-google-signin-button-directive'
  import rest from '@/plugins/rest'

  export default {
    directives: {
      GoogleSignInButton
    },

    data() {
      return {
        clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        error: false
      }
    },

    methods: {
      OnGoogleAuthSuccess(idToken) {
        const self = this;

        rest.auth(idToken).then(data => {
          if (data.valid) {
            // Store this idToken for further requests.
            data.idToken = idToken;
            self.$cookies.set("idToken", idToken, "1h");
            self.$store.dispatch('setCurrentUser', data);
            rest.setIdToken(idToken);
          }
          else {
            this.error = true;
          }
        })
      },

      OnGoogleAuthFail(error) {
        console.log(error)
      },

    },

    computed: {
      ...mapState([
        'currentUser',
      ]),
    },

  }
</script>

<style lang="scss" scoped>
</style>